 <template>
  <div class="footer">
    <!-- <div class="float-right">بیتا ایده</div> -->
    <div><strong> تمام حقوق و امتیاز سایت متعلق به تیم بیتا ایده می باشد </strong>&copy; ۱۳۹۹ {{ $appVersion }}</div>
  </div>
</template>
<script>
export default {
    
}
</script>